export class ValidationUtils {
    static isValidPincode(pincode: string): boolean {
        return /^\d{6}$/.test(pincode.trim()); // (!) for not patten match 
    }

    static isValidContactNumber(contact: string): boolean {
        return /^[1-9]\d{9}$/.test(contact);
    }

    static isValidEmail(email: string): boolean {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email.trim());
    }

    static isAlphabetOnly(value: string): boolean {
        return /^[a-zA-Z]+$/.test(value.trim());
    }
}